import { forwardRef } from 'react';

import { Skeleton as MuiSkeleton } from '@mui/material';
import { Skeleton as DsSkeleton, cn } from '@natter-co/design-system';
import { VISUAL_REFRESH } from 'common/utils';

import { toDsProps } from './toDsProps';

import type { SkeletonProps as MuiSkeletonProps } from '@mui/material';

export type SkeletonProps = MuiSkeletonProps & {
  /** Typed because hyphenated JSX attributes are unchecked; `toDsProps` has to see it. */
  'data-testid'?: string;
};

export const Skeleton = forwardRef<HTMLSpanElement, SkeletonProps>((props, ref) => {
  // The visual-refresh gate lives here, not at the call sites. `null` falls through to MUI.
  const dsProps = VISUAL_REFRESH ? toDsProps(props) : null;

  if (!dsProps) return <MuiSkeleton ref={ref} {...props} />;

  const { shape, className, style, testId, inline, fitsLine, animated } = dsProps;

  return (
    <DsSkeleton
      ref={ref}
      shape={shape}
      fit={fitsLine ? 'line' : 'fixed'}
      animated={animated}
      data-testid={testId}
      className={cn(inline && (fitsLine ? 'inline-flex' : 'inline-block'), className)}
      style={style}
    />
  );
});
